import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentLanguage } from '../language';
import { getResourcesFromState, fetchResources } from '.';
/**
 * Get resources from state or retrieve resources as needed
 * @param project Project name
 * @param getResources Utility for reading resources from file
 * @returns Resource object
 */
const useResources = (project, getResources) => {
    const dispatch = useDispatch();
    const resources = useSelector(state => getResourcesFromState(state, project));
    const language = useSelector(state => selectCurrentLanguage(state.language));
    useEffect(() => {
        dispatch(fetchResources({ project, language, getResources }));
    }, [dispatch, project, language]);
    return resources;
};
export default useResources;
